
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/technical-verification-pending",
      function () {
        return require("private-next-pages/technical-verification-pending.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/technical-verification-pending"])
      });
    }
  